import * as React from 'react';
export const nfcuSvg = React.forwardRef(function nfcuSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#003769',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M25.98 16.04c0-5.2-3.98-9.47-9.06-9.91-.3-.04-.59-.08-.88-.08-.3 0-.56.04-.85.08A9.95 9.95 0 0 0 8.12 10l-.19.25-.18.26a9.94 9.94 0 0 0 7.37 15.43c.3.04.59.08.88.08.3 0 .59-.04.88-.07a9.97 9.97 0 0 0 9.1-9.91zM20.6 23.4h-1.4c.41-.77.74-1.73.96-2.76h2.32a10.45 10.45 0 0 1-1.88 2.76zM9.55 20.6h2.32c.26 1.07.6 2 1 2.77h-1.4a8.82 8.82 0 0 1-1.92-2.77zm-2.83-4.23H8c.03 1.29.25 2.5.66 3.65H7.6a8.86 8.86 0 0 1-.88-3.65zm2.94-5.12a9.3 9.3 0 0 1 1.8-2.54h1.4c-.29.59-.54 1.29-.8 2.1l-.08.3-.07.29c0 .03 0 .03-.04.07H9.55l.11-.22zm12.82.22h-2.32a15.08 15.08 0 0 0-.96-2.76h1.4c.74.73 1.4 1.7 1.88 2.76zm2.84 4.27h-1.29c-.04-1.29-.26-2.5-.66-3.64h1.07c.55 1.1.84 2.32.88 3.64zm-1.88 0h-2.76c0-1.29-.15-2.5-.37-3.64h2.43c.4 1.1.66 2.32.7 3.64zm-10.87-4.5c.26-.99.6-1.83 1-2.53h2.14v2.76h-3.17l.03-.22zm.63-3.2h-1.03c.55-.4 1.14-.73 1.77-1-.26.3-.52.63-.74 1zm2.5-1.32v1.32h-1.73a3.04 3.04 0 0 1 1.74-1.32zm.63 1.32V6.72c.63.1 1.22.59 1.73 1.32h-1.73zm2.14.67c.4.77.77 1.7 1.03 2.76h-3.17V8.7h2.14zM15.7 12.1v3.64h-3.69c0-1.25.15-2.5.37-3.64h3.32zm0 4.27v3.65h-3.32a18.8 18.8 0 0 1-.37-3.65h3.69zm0 4.23v2.77h-2.14c-.4-.78-.77-1.7-1.03-2.77h3.17zm0 3.43v1.33c-.63-.11-1.22-.6-1.74-1.33h1.74zm.62 0h1.73c-.51.74-1.1 1.22-1.73 1.33v-1.33zm0-.63v-2.76h3.17a11.41 11.41 0 0 1-1.03 2.76h-2.14zm0-3.42v-3.65h3.72c-.03 1.3-.15 2.5-.37 3.65h-3.35zm0-4.24V12.1h3.32c.22 1.1.37 2.35.37 3.64h-3.69zm2.5-7.7c-.25-.37-.47-.7-.77-1 .63.23 1.26.56 1.8 1h-1.02zm-7.07 4.06c-.22 1.14-.36 2.39-.36 3.64H8.63c.04-1.25.26-2.5.7-3.64h2.43zM8 15.74H6.7c.04-1.29.34-2.5.9-3.64h1.06A10.85 10.85 0 0 0 8 15.74zm.62.63h2.77c0 1.29.14 2.5.36 3.65H9.33a10.87 10.87 0 0 1-.7-3.65zm4.57 7.66c.22.37.48.7.77 1a6.22 6.22 0 0 1-1.8-1h1.03zm5.64 0h1.03c-.55.44-1.14.77-1.8 1 .29-.3.55-.63.77-1zm1.47-4.05c.22-1.1.33-2.36.37-3.65h2.76c-.04 1.3-.3 2.54-.7 3.65H20.3zm3.76-3.61h1.29a8.72 8.72 0 0 1-.89 3.65H23.4c.4-1.15.63-2.36.67-3.65zm.07-4.9h-1a10.89 10.89 0 0 0-1.69-2.76h.3c.95.73 1.76 1.7 2.4 2.76zM10.3 8.7h.3a9.5 9.5 0 0 0-1.37 1.99l-.15.29-.14.3c-.04.07-.08.14-.08.18H7.9c.14-.3.33-.55.51-.85a9.28 9.28 0 0 1 1.88-1.91zM7.9 20.6h1a10.89 10.89 0 0 0 1.7 2.76h-.3a9.61 9.61 0 0 1-2.4-2.77zm13.86 2.8h-.3a9.14 9.14 0 0 0 1.7-2.77h1a10.7 10.7 0 0 1-2.4 2.76z',
      }),
    ),
  );
});
nfcuSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var nfcu = {
  category: 'brand',
  colorable: false,
  name: 'nfcu',
  svg: nfcuSvg,
};
